<div class="topup-result-container">
    <div class="topup-result-card">
        <span class="material-icons cancel-icon">cancel</span>
        <h2>{{'TopupSim.cancelTitle' | translate}}</h2>
        <p>{{'TopupSim.cancelMessage' | translate}}</p>
        <p class="redirect-text">{{'TopupSim.redirectingIn' | translate}} {{countdown}}s</p>
        <button mat-raised-button color="primary" (click)="goToDevices()">
            {{'TopupSim.backToDevices' | translate}}
        </button>
    </div>
</div>